module.exports = __webpack_public_path__ + "static/media/48.4144c841.png";